import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import { ReferenceInputMethodProps } from './types'

export interface SearchMethodToggleProps<T extends object> {
  searchMethod: number
  onChange: (value: number) => void
  inputs: {
    label: string
    component: (props: ReferenceInputMethodProps<T>) => React.ReactNode
  }[]
}

export function SearchMethodToggle<T extends object>({
  searchMethod,
  onChange,
  inputs
}: SearchMethodToggleProps<T>) {
  return (
    <div className='mb-1 flex items-center justify-between'>
      Search By:{' '}
      <ToggleGroup
        type='single'
        variant='outline'
        size='sm'
        value={String(searchMethod)}
        onValueChange={value => {
          // radix clears the value when the active item is re-pressed; ignore that.
          if (value) onChange(Number(value))
        }}
      >
        {inputs.map((inputMethod, index) => (
          <ToggleGroupItem key={inputMethod.label} value={String(index)}>
            {inputMethod.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  )
}
